import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import CustomDialogBox from "../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class InventoryBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      categoryId: "",
      categoryName: "",
      editStatus: false,
    };
  }

  handleCategoryChange = (e) => {
    this.setState({
      categoryName: e.target.value,
    });
  };

  handleDialogOpen = (categoryId) => {
    this.setState({
      dialogOpen: true,
      categoryId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleEditCategory = async (categoryId, categoryData) => {
    this.setState({
      editStatus: true,
      categoryId,
      categoryName: this.props.data.categoryName,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDeleteCategory = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/item-categories/${this.state.categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Item category deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getItemCategories();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteCategory();
      }
    }
  };

  handleEditSubmit = async () => {
    try {
      const response = await Axios.put(
        `${url}/api/item-categories/${this.state.categoryId}`,
        { categoryName: this.state.categoryName },
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Item category updated successfully") {
        this.handleCancelEdit();
        this.props.getItemCategories();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleEditSubmit();
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow key={index}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.categoryName}</TableCell>
        <TableCell align="center">
          <p
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Tooltip
              arrow
              title="Decrease stock"
              className={classes.tooltip}
              onClick={() =>
                this.props.history.push(
                  `/administration/inventory/details/${data._id}`
                )
              }
            >
              <ExpandMoreIcon />
            </Tooltip>
            <>{data.currentStock}</>
          </p>
        </TableCell>

        <TableCell align="center">
          <Tooltip
            title="Info"
            arrow
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/inventory/details/${data._id}`
              )
            }
          >
            <InfoIcon />
          </Tooltip>
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditCategory(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteCategory}
        />
      </TableRow>
    ) : (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="categoryName"
            type="text"
            label="Category Name"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="change the current category name"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.categoryName}
            onChange={this.handleCategoryChange}
          />
        </TableCell>
        <TableCell align="center">{data.currentStock}</TableCell>
        <TableCell align="center">
          <Tooltip
            title="Update"
            arrow
            onClick={this.handleEditSubmit}
            className={classes.tooltip}
          >
            <CheckCircleIcon />
          </Tooltip>
          <Tooltip
            title="Cancel"
            arrow
            onClick={this.handleCancelEdit}
            className={classes.tooltip}
          >
            <CancelIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(InventoryBody)));
